/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Newreleasesdesc2Inputs */

const id_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi untuk rilis game baru`)
};

const ms_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan untuk keluaran permainan baharu`)
};

const da_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikationer for nye spiludgivelser`)
};

const de_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen zu neuen Spielveröffentlichungen`)
};

const en_us2_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications for new game releases`)
};

const es_es2_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones de nuevos lanzamientos de juegos`)
};

const es_mx2_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones de nuevos lanzamientos de juegos`)
};

const fil_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga notipikasyon para sa bagong release ng laro`)
};

const fr_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications pour les nouvelles sorties de jeux`)
};

const it_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche per le nuove uscite di giochi`)
};

const hu_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értesítések új játékmegjelenésekről`)
};

const nl_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen voor nieuwe gamereleases`)
};

const no_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varsler om nye spillutgivelser`)
};

const pl_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia o nowych premierach gier`)
};

const pt_br2_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications for new game releases`)
};

const pt_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações para novos lançamentos de jogos`)
};

const ro_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificări pentru lansări noi de jocuri`)
};

const fi_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitukset uusista pelijulkaisuista`)
};

const sv_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiser för nya spelrelease`)
};

const vi_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo về bản phát hành game mới`)
};

const tr_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni oyun çıkışları için bildirimler`)
};

const cs_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oznámení o nových vydáních her`)
};

const bg_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Известия за нови издания на игри`)
};

const ru_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления о новых релизах игр`)
};

const uk_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сповіщення про нові релізи ігор`)
};

const ar_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إشعارات بإصدارات الألعاب الجديدة`)
};

const hi_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नए गेम रिलीज़ की सूचनाएँ`)
};

const th_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแจ้งเตือนสำหรับการวางจำหน่ายเกมใหม่`)
};

const ja_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新作ゲームリリースの通知`)
};

const zh_cn2_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications for new game releases`)
};

const zh_hant1_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications for new game releases`)
};

const ko_notifications_simple_newreleasesdesc2 = /** @type {(inputs: Notifications_Simple_Newreleasesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신규 게임 출시 알림`)
};

/**
* | output |
* | --- |
* | "Notifications for new game releases" |
*
* @param {Notifications_Simple_Newreleasesdesc2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_newreleasesdesc2 = /** @type {((inputs?: Notifications_Simple_Newreleasesdesc2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Newreleasesdesc2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "ms") return ms_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "da") return da_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "de") return de_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "fil") return fil_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "fr") return fr_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "it") return it_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "hu") return hu_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "nl") return nl_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "no") return no_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "pl") return pl_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "pt") return pt_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "ro") return ro_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "fi") return fi_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "sv") return sv_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "vi") return vi_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "tr") return tr_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "cs") return cs_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "bg") return bg_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "ru") return ru_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "uk") return uk_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "ar") return ar_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "hi") return hi_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "th") return th_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "ja") return ja_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_newreleasesdesc2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_newreleasesdesc2(inputs)
	return ko_notifications_simple_newreleasesdesc2(inputs)
});
export { notifications_simple_newreleasesdesc2 as "notifications.simple.newReleasesDesc" }